import React from 'react';
import { NavLink } from 'react-router-dom';
import CollapsibleSection from '../CollapsibleSection';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import { MAIN_ONE_THEME } from '../../constants';
import { IApplication } from '../../IApplication';

interface IAppLauncherModulesProps {
  applications: Record<string, IApplication>;
  searchKey: string;
  closeModal: () => void;
}

const useStyles = makeStyles()((theme) => ({
  collapseContent: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      gap: '20px',  // reduced gap between sections
    },
  moduleLink: {
    margin: '3px 0',
    color: MAIN_ONE_THEME.palette.primary4.main,
    textDecoration: 'none',
    fontSize: '19px',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  activeLink: {
    fontWeight: 'bold',
    fontSize: '17px',
    fontFamily: 'sans-serif',
  },
  submoduleLink: {
    marginLeft: '1rem',
  },
}));

const AppLauncherModules: React.FC<IAppLauncherModulesProps> = ({
  applications,
  closeModal,
  searchKey,
}) => {
  const { classes } = useStyles();

  // Filter apps if needed
  const filteredApps = Object.values(applications).filter((app) => {
    if (!searchKey.trim()) return true;
    // match either the app or its modules by title
    const matchApp = app.title.toLowerCase().includes(searchKey.toLowerCase());
    const matchModule = Object.values(app.modules).some((mod) =>
      mod.title.toLowerCase().includes(searchKey.toLowerCase()),
    );
    return matchApp || matchModule;
  });

  return (
    <CollapsibleSection
      title={'All Modules'}
      className={classes.collapseContent}
      open
    >
      {Object.values(applications).map((app) =>
        Object.keys(app.modules).map(
          (moduleName) =>
            (!searchKey ||
              !searchKey.trim() ||
              app.modules[moduleName].title
                .toLowerCase()
                .includes(searchKey.toLowerCase())) && (
              <NavLink
                key={moduleName}
                to={app.route + app.modules[moduleName].route}
                className={({ isActive }) =>
                  clsx(classes.moduleLink, { [classes.activeLink]: isActive })
                }
                onClick={closeModal}
              >
                {app.modules[moduleName].title}
              </NavLink>
            )
        )
      )}
    </CollapsibleSection>
  );
};

export default AppLauncherModules;